/**
 * Sticky bottom Status-Bar.
 *
 * Pulse-dot indicates stream health:
 *   green → updates flowing
 *   amber → no update for 8s+ (stale)
 *   red   → no update for 20s+ (dead)
 *
 * Color thresholds for vital values are applied via [data-warn] attribute.
 */
import { visibleInterval } from '../core/visibility.js';

export class StatusBar {
  constructor() {
    this.el = document.getElementById('statusbar');
    this.pulse = document.getElementById('sb-pulse');
    this.lastUpdate = 0;
    if (this.el) this._scheduleStaleCheck();
  }

  apply(vitals) {
    if (!this.el) return;

    for (const el of this.el.querySelectorAll('[data-vital]')) {
      const path = el.dataset.vital.split('.');
      let v = vitals;
      for (const k of path) v = v?.[k];
      if (v != null) el.textContent = String(v);
    }

    this._warn(vitals.sys?.cpu_pct,    80, 95, '[data-vital="sys.cpu_pct"]');
    this._warn(vitals.sys?.ram_pct,    80, 95, '[data-vital="sys.ram_pct"]');
    this._warn(vitals.disk?.data_pct,  85, 95, '[data-vital="disk.data_pct"]');
    this._warn(vitals.sys?.load_1,      8, 16, '[data-vital="sys.load_1"]');

    this.lastUpdate = Date.now();
    if (this.pulse) this.pulse.className = 'sb__pulse';   // back to alive
  }

  setStreamState(state) {
    if (!this.pulse) return;
    this.pulse.className = 'sb__pulse';
    if (state === 'closed') this.pulse.classList.add('is-dead');
    if (state === 'connecting') this.pulse.classList.add('is-stale');
  }

  _warn(val, warnAt, errAt, sel) {
    if (!this.el) return;
    const el = this.el.querySelector(sel);
    if (!el) return;
    el.removeAttribute('data-warn');
    if (val >= errAt) el.dataset.warn = 'error';
    else if (val >= warnAt) el.dataset.warn = 'warn';
  }

  _scheduleStaleCheck() {
    // Hidden tab: no point aging the pulse nobody sees; on return the
    // immediate visibleInterval-fire re-evaluates the age right away.
    visibleInterval(() => {
      if (!this.pulse) return;
      const age = Date.now() - this.lastUpdate;
      if (age > 8000)  this.pulse.classList.add('is-stale');
      if (age > 20000) { this.pulse.classList.remove('is-stale'); this.pulse.classList.add('is-dead'); }
    }, 2000);
  }
}
